import { render, staticRenderFns } from "./ViewAllCollaborators.vue?vue&type=template&id=313f1b5c&"
import script from "./ViewAllCollaborators.vue?vue&type=script&lang=js&"
export * from "./ViewAllCollaborators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports